module.exports = __webpack_public_path__ + "img/usp.26d0ca63.svg";